

function ArrowRight() {
    return (
      <div
          className="
            translate-x-[-4px]
            group-hover:opacity-100 group-hover:translate-x-0
            transition-all duration-300 ease-out
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icon-tabler-arrow-narrow-right"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M5 12h14" />
            <path d="M15 16l4-4" />
            <path d="M15 8l4 4" />
          </svg>
        </div>
    )
  }
  
  export default ArrowRight;